import { Expose, Transform } from 'class-transformer';

import { Model } from './model';

export class BlockedStudentsReport extends Model {
  @Expose()
  @Transform(({ value }) => (value ? new Date(value) : null))
  blockingTime: Date;
  @Expose() id: string;
  @Expose() studentId: string;
  @Expose() studentName: string;
  @Expose() teacherId: string;
  @Expose() teacherName: string;
}
